import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import variables from 'packages/ui/variables';

const Meta = styled('ul')`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    margin-left: 20px;
  }
`;

const Title = styled(Link)`
  font-size: 13px;
`;

const ActionButton = styled('span')`
  background-color: transparent;
  border: none;
  color: ${props => variables.color[props.mood]};
  cursor: pointer;
  display: inline-block;
  height: 16px;
  line-height: 16px;
  margin: 0 10px;
  padding: 0;
  vertical-align: middle;
  width: 16px;

  &:hover {
    text-decoration: none;
  }

  svg {
    fill: currentColor !important;
    width: 16px;
  }
`;

const Table = styled('table')`
  border-collapse: collapse;
  color: inherit;
  width: 100%;

  th {
    color: #999;
    font-weight: normal;
  }

  td,
  th {
    padding: 13px 10px;
    text-align: right;
    vertical-align: middle;
  }

  tr th:first-child,
  tr td:first-child {
    padding-right: 20px;
  }

  tr th:last-child,
  tr td:last-child {
    padding-left: 20px;
  }

  tr > :last-child {
    ${props => props.justify && 'text-align: left;'}
  }

  tbody tr td {
    border-top: 1px solid #eee;
  }

  tbody:hover tr td {
    background-color: #fcfcfc;
  }

  .actions > :last-child {
    margin-left: 0;
  }

  .ltr {
    direction: ltr;
  }
`;

function Action({ tooltip, ...rest }) {
  return <ActionButton key="button" {...rest} />;
}

function ActionLink(props) {
  return <Action as={Link} {...props} />;
}

Table.propTypes = {
  justify: PropTypes.bool
};

Action.propTypes = {
  mood: PropTypes.string,
  tooltip: PropTypes.string
};

Action.defaultProps = {
  mood: 'info',
  tooltip: ''
};

const Tbody = styled.tbody`
  td {
    text-align: right !important;
  }
  &:hover {
    td {
      background: none !important;
    }
  }
`;
const Thead = styled.thead`
  th {
    text-align: right !important;
  }
`;

export { Action, ActionLink, Meta, Title, Tbody, Thead };

export default Table;
